document.addEventListener("DOMContentLoaded", function() {
    const menuItem = document.querySelectorAll('.header__main-menu-item');
    const menuOverlay = document.querySelector('#overlay_menu');
    
    let activeItem = null;
    
    function closeMenu() {
        if (activeItem) {
            activeItem.querySelector('.header__menu-dropdown').classList.remove('active-dropdown');
            menuOverlay.classList.remove('active_overlay');
            document.querySelector('body').classList.remove('no-scroll');
            activeItem.classList.remove('active_link');
            activeItem = null;
        }
    }
    
    // Add a click event listener to the overlay to close the menu
    menuOverlay.addEventListener('click', closeMenu);
    
    // Add a click event listener to each .header__main-menu-item
    menuItem.forEach(item => {
        item.querySelector('.header__main-menu-item--link').addEventListener('click', (e) => {
            e.preventDefault(); // Prevent the default link behavior
            
            if (activeItem === item) {
              
                closeMenu();
            } else {
               
                closeMenu(); // Close any open menu
    
                const dropdown = item.querySelector('.header__menu-dropdown');
                if (dropdown) {
                    dropdown.classList.add('active-dropdown');
                    menuOverlay.classList.add('active_overlay');
                    document.querySelector('body').classList.add('no-scroll');
                    item.classList.add('active_link');
                    activeItem = item;
                }
            }

            // css variables
        
        // Toggle a class to apply the styles
        var menu_height = document.querySelector('.header__menu-dropdown.active-dropdown')
    
        if(menu_height){
            var menu_height_result = menu_height.offsetHeight;
            document.documentElement.style.setProperty("--menu-height", "".concat(menu_height_result, "px"));
        }
        var divElement = document.querySelector('.header__menu-dropdown.active-dropdown .menu_desktop_container'); 
     
        if(divElement){
            var divWidth = divElement.offsetWidth;
            document.documentElement.style.setProperty("--width-menu", "".concat(divWidth, "px"));

        }
        var divElement_promo = document.querySelector('.header__menu-dropdown.active-dropdown .menu_desktop_container .promo_banner'); 
        if(divElement_promo){
            var divWidth_promo = divElement_promo.offsetWidth;
        document.documentElement.style.setProperty("--width-menu_promo", "".concat(divWidth_promo, "px"));
        }

        });
    });
    


    // Function to update CSS variables on window resize
    function updateCSSVariables() {
        var divElement = document.querySelector('.header__menu-dropdown.active-dropdown .menu_desktop_container');
        if (divElement) {
            var divWidth = divElement.offsetWidth;
            document.documentElement.style.setProperty("--width-menu", divWidth + "px");
        }

        var divElement_promo = document.querySelector('.header__menu-dropdown.active-dropdown .menu_desktop_container .promo_banner');
        if (divElement_promo) {
            var divWidth_promo = divElement_promo.offsetWidth;
            document.documentElement.style.setProperty("--width-menu_promo", divWidth_promo + "px");
        }
    }

    // Initial update
    updateCSSVariables();

    // Add a window resize event listener
    window.addEventListener("resize", updateCSSVariables);
})